import React, { useState } from "react";
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import axios from "axiosClient";
import { Formik, Form, Field } from "formik";

import { Colxx } from "../components/common/CustomBootstrap";
import UserLayout from "layout/UserLayout";
import { useUser } from "auth/useUser";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "components/LanguageDropdown";

const ResetPassword = ({ loading }) => {
  const navigate = useNavigate();
  const { token } = useParams();
  const user = useUser();
  const { t } = useTranslation();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    password: "",
    date: "",
    server: "",
  });

  const onUserLogin = async (e) => {
    e.preventDefault();
    if (!loading) {
      if (password === "") {
        setErrors({ ...errors, password: t("enterNewPassword") });
      } else if (password.length < 6) {
        setErrors({
          ...errors,
          password: t("atLeast6"),
        });
      } else if (password !== confirmPassword) {
        setErrors({
          ...errors,
          password: t("passwordsShouldMatch"),
        });
      } else if (password !== "") {
        try {
          const response = await axios.post("/api/reset-password", {
            token,
            password,
          });
          if (response.status === 200) {
            setErrors({ ...errors, server: "" });
            // eslint-disable-next-line no-underscore-dangle
            navigate("/login");
          } else {
            setErrors({ ...errors, server: response.data });
          }
        } catch (error) {
          // console.log(error.response);
          setErrors({ ...errors, server: error.response.data });
        }
      }
    }
  };

  return (
    <UserLayout>
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">Mock TKT</p>
              <p className="white mb-0">{t("resetPasswordText")}</p>
            </div>
            <div className="form-side">
              <div className="d-flex align-items-center justify-content-between">
                <div></div>
                <LanguageDropdown />
              </div>
              <CardTitle className="mb-4">{t("resetPassword")}</CardTitle>

              <Formik>
                {() => (
                  <Form
                    className="av-tooltip tooltip-label-bottom"
                    onSubmit={onUserLogin}
                  >
                    <FormGroup className="form-group has-float-label">
                      <Label>{t("newPassword")}</Label>
                      <Field
                        className="form-control"
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setErrors({ ...errors, server: "", password: "" });
                        }}
                      />
                      {errors.password !== "" && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group has-float-label">
                      <Label>{t("passwordConfirm")}</Label>
                      <Field
                        className="form-control"
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setErrors({ ...errors, server: "", password: "" });
                        }}
                      />
                    </FormGroup>
                    <p className="text-danger">{errors.server}</p>

                    <div className="d-flex justify-content-between align-items-center">
                      <NavLink to="/login">{t("login")}</NavLink>
                      <Button
                        type="submit"
                        color="primary"
                        className={`btn-shadow btn-multiple-state ${
                          loading ? "show-spinner" : ""
                        }`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">{t("submit")}</span>
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </Colxx>
      </Row>
    </UserLayout>
  );
};

export default ResetPassword;
